import React from "react";
import { productVersionsMappingsApi } from "@/apis/apis";
import { columns } from "./Columns";
import MappingBaseTable from "../BaseTable";
import ProductVersionModal from "@/Modals/WebDataManagement/Mapping/ProductVersion/Modal";
import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/Mapping/BaseImport/baseImportData";

export default function ProductVersionPage() {
  return (
    <MappingBaseTable
      label="Product - Version"
      apiURL={productVersionsMappingsApi}
      columns={columns()}
      ModalComponent={ProductVersionModal}
      importData={BASE_IMPORT_DATA.PRODUCT_VERSION}
      enableAdd={false}
      enableEdit={true}
      enableDelete={false}
    />
  );
}
